import { useState } from "react";

function Node({ k, v, depth }: { k?: string; v: unknown; depth: number }) {
  const [open, setOpen] = useState(depth < 2);
  const key = k !== undefined ? <span className="key">{JSON.stringify(k)}: </span> : null;
  if (v === null || v === undefined) return <div>{key}<span className="lit">{String(v)}</span></div>;
  if (typeof v === "string") {
    const long = v.length > 400;
    return (
      <div>
        {key}
        <span className="str">{long && !open ? JSON.stringify(v.slice(0, 400)) + "…" : JSON.stringify(v)}</span>
        {long && (
          <button className="small" style={{ marginLeft: 6 }} onClick={() => setOpen(!open)}>
            {open ? "less" : `+${v.length - 400} chars`}
          </button>
        )}
      </div>
    );
  }
  if (typeof v === "number" || typeof v === "boolean") return <div>{key}<span className={typeof v === "number" ? "num" : "lit"}>{String(v)}</span></div>;
  const isArr = Array.isArray(v);
  const entries = isArr ? (v as unknown[]).map((x, i) => [String(i), x] as const) : Object.entries(v as object);
  if (entries.length === 0) return <div>{key}<span className="lit">{isArr ? "[]" : "{}"}</span></div>;
  return (
    <details open={open} onToggle={(e) => setOpen((e.target as HTMLDetailsElement).open)}>
      <summary>
        {key}
        <span className="lit">{isArr ? `[${entries.length}]` : `{${entries.length}}`}</span>
      </summary>
      {open && entries.map(([ek, ev]) => <Node key={ek} k={isArr ? undefined : ek} v={ev} depth={depth + 1} />)}
    </details>
  );
}

export function JsonView({ value }: { value: unknown }) {
  return (
    <div className="json">
      <Node v={value} depth={0} />
    </div>
  );
}
